import { c as _c } from "react/compiler-runtime";
import { useSearchReminder } from "@website/accommodation-ui/tour-reminder/queries";
import { ReminderSwitchBoxClient } from "@website/accommodation-ui/tour-reminder/reminder-switch-box/reminder-switch-box";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { Skeleton } from "@website/ui/skeleton";
interface Properties {
  origin: string;
  dest: string;
  stDate: string;
  rtDate: string;
}
export const TourReminder = t0 => {
  const $ = _c(9);
  const {
    origin,
    dest,
    stDate,
    rtDate
  } = t0;
  const {
    isLoggedIn
  } = useLoginStatus();
  const {
    isLoading,
    data: reminder,
    refetch
  } = useSearchReminder(isLoggedIn);
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="mx-auto"><div className="w-[250px]"><Skeleton height={64} /></div></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = reminder?.length;
  let t2;
  if ($[1] !== dest || $[2] !== origin || $[3] !== refetch || $[4] !== reminder || $[5] !== rtDate || $[6] !== stDate || $[7] !== t1) {
    t2 = <ReminderSwitchBoxClient refetch={refetch} reminderArray={reminder} reminderId={t1} origin={origin} dest={dest} rtDate={rtDate} stDate={stDate} />;
    $[1] = dest;
    $[2] = origin;
    $[3] = refetch;
    $[4] = reminder;
    $[5] = rtDate;
    $[6] = stDate;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};